"use client";

import { QueryClientProvider } from "react-query";
import React from "react";
import { queryClient } from "@/lib/queryClient";

export const ReactQueryClientProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
